import React, { createElement } from 'react'
import PropTypes from 'prop-types'
import LoadingIndicator from '../LoadingIndicator'
import WertErmittlerModalButton from '../WertErmittlerModalButton'
import './style.scss'

import { openModal as loginOpenModal } from '../../redux/modules/loginModal'
import app from '../../init/react/Bootstrapper'

const Button = ({
  alignment,
  title,
  url,
  target,
  rel,
  style,
  inlined,
  classes,
  dataSet,
  icon,
  disabled,
  callback,
  loading,
  children,
  isPreview,
  fullWidth,
  openWertermittler,
  openModal,
  onClick,
  showTitleAttr,
  type: htmlType,
}) => {
  if (!children && !title) {
    return false
  }

  let type = 'button'

  let props = {
    className: `btn btn--${style}`,
  }

  if (onClick) {
    props.onClick = onClick
  }

  if (icon) {
    props.className += ' has-icon'
  }

  if (disabled || loading) {
    props.className += ' btn--disabled'
  }

  if (classes.length) {
    classes.map(className => {
      props.className += ' ' + className
    })
  }
  if (url) {
    props.href = url
    type = 'a'
  } else {
    props.type = htmlType || 'button'
  }
  if (title && showTitleAttr) {
    props.title = title
  }
  if (target) props.target = target
  if (rel) props.rel = rel

  const store = app.getStore()
  const { dispatch } = store

  if (callback && typeof callback === 'function') {
    props.onClick = () => callback(dataSet)
  } else if (openModal) {
    if (openModal === 'login') {
      props.onClick = e => {
        e.preventDefault()
        dispatch(loginOpenModal(''))
      }
    }
  }

  if (isPreview && !callback) {
    props = { ...props, onClick: e => e.preventDefault() }
  }

  if (fullWidth) {
    props.className += ' btn--fullwidth'
  }

  if (typeof dataSet !== 'undefined' && Object.keys(dataSet).length > 0) {
    let newDataSet = new Object()
    for (let dataProp in dataSet) {
      Object.assign(newDataSet, { [`data-${dataProp}`]: dataSet[dataProp] })
    }

    props = { ...props, ...newDataSet }
  }

  return (
    <div
      className={`dhsv_button align-${alignment}${
        inlined ? ' is-inlined' : ''
      }`}
    >
      {!isPreview && (openWertermittler || openModal === 'wertermittler') ? (
        <WertErmittlerModalButton
          buttonTitle={children ? children : decodeEntities(title)}
        />
      ) : (
        createElement(
          type,
          props,
          <>
            {children ? children : decodeEntities(title)}
            {!loading && icon && <div className="button-icon" />}
            {loading && <LoadingIndicator />}
          </>
        )
      )}
    </div>
  )
}

function decodeEntities(encodedString) {
  var textArea = document.createElement('textarea')
  textArea.innerHTML = encodedString
  return textArea.value
}

Button.defaultProps = {
  style: 'primary',
  alignment: 'left',
  classes: [],
  inlined: false,
  loading: false,
  isPreview: false,
  openWertermittler: false,
  showTitleAttr: false,
}

Button.propTypes = {
  alignment: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  style: PropTypes.string,
  inlined: PropTypes.bool,
  classes: PropTypes.array,
  dataSet: PropTypes.object,
  icon: PropTypes.bool,
  disabled: PropTypes.bool,
  callback: PropTypes.func,
  loading: PropTypes.bool,
  children: PropTypes.any,
  isPreview: PropTypes.bool,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  openWertermittler: PropTypes.bool,
  openModal: PropTypes.string,
  showTitleAttr: PropTypes.bool,
  type: PropTypes.string,
}

export default Button
